import React, { useEffect, useState, useRef } from 'react';
var Highcharts = require('highcharts');
import { CAMPAING_PROMISE_TYPES, PRODUCT_TYPES } from '../../../constants/enums';
import { useError } from '../Contexts/ErrorContext';
import styles from './Environment.module.css';

const EnvironmentPlay = ({ orderlinesData, campaignPromiseType, campaignType, showDaysGraph, alignWithFooterNote }) => {
    const containerRef = useRef(null);
    const chartRef = useRef(null);
    const [environment, setEnvironment] = useState([]);
    const [yLabel, setYLabel] = useState('');
    const { showError } = useError();

    //console.log('env orderlinesData', orderlinesData);

    useEffect(() => {
        if (orderlinesData) {
            switch (campaignType) {
                case PRODUCT_TYPES.PLAY:
                    switch (campaignPromiseType) {
                        case CAMPAING_PROMISE_TYPES.SE_DIGITAL_EAVAC:
                        case CAMPAING_PROMISE_TYPES.SE_DIGITAL_EAVAC_FILLER:
                        case CAMPAING_PROMISE_TYPES.DK_PLAY_VAC:
                        case CAMPAING_PROMISE_TYPES.DK_PLAY_VAC_PANELS:
                        case CAMPAING_PROMISE_TYPES.DK_AIRPORT_VAC:
                        case CAMPAING_PROMISE_TYPES.DK_AIRPORT_VAC_PANELS:
                        case CAMPAING_PROMISE_TYPES.DK_PLAY_VAC_2_0:
                        case CAMPAING_PROMISE_TYPES.DK_PLAY_VAC_PANELS_2_0:
                        case CAMPAING_PROMISE_TYPES.DK_AIRPORT_VAC_2_0:
                        case CAMPAING_PROMISE_TYPES.DK_AIRPORT_VAC_PANELS_2_0:                            
                            if (orderlinesData.playData.spotlengths &&
                                orderlinesData.playData.useAlternateContacts &&
                                orderlinesData.playData.spotlengths.length === 1 &&
                                orderlinesData.playData.spotlengths[0] === 10) {
                                setEnvironment(orderlinesData.playData.alternateContacts.environment);
                            } else {
                                setEnvironment(orderlinesData.playData.contacts.environment);
                            }
                            break;
                        case CAMPAING_PROMISE_TYPES.NO_PLAY_VAC_FILLER:
                        case CAMPAING_PROMISE_TYPES.NO_PLAY_VAC:
                        case CAMPAING_PROMISE_TYPES.NO_PLAY_VAC_2_0:
                        case CAMPAING_PROMISE_TYPES.NO_PLAY_VAC_FILLER_2_0:                             
                            if (orderlinesData.playData.spotlengths &&
                                orderlinesData.playData.useAlternateContacts &&
                                orderlinesData.playData.spotlengths.length === 1 &&
                                orderlinesData.playData.spotlengths[0] === 5) {
                                setEnvironment(orderlinesData.playData.alternateContacts.environment);
                            } else {
                                setEnvironment(orderlinesData.playData.contacts.environment);
                            }
                            break;
                        case CAMPAING_PROMISE_TYPES.SE_DIGITAL_SOV:
                        case CAMPAING_PROMISE_TYPES.SE_DIGITAL_PLAYS:
                        case CAMPAING_PROMISE_TYPES.SE_DIGITAL_NO_PROMISE:
                        case CAMPAING_PROMISE_TYPES.NO_PLAY_PLAYS:
                        case CAMPAING_PROMISE_TYPES.NO_PLAY_PLAYS_2_0:  
                        case CAMPAING_PROMISE_TYPES.NO_AIRPORT_PLAYS_2_0_1:                          
                        case CAMPAING_PROMISE_TYPES.DK_PLAY_PLAYS:
                        case CAMPAING_PROMISE_TYPES.DK_PLAY_PLAYS_2_0:    
                        case CAMPAING_PROMISE_TYPES.DK_DIGITAL_SOV:
                        case CAMPAING_PROMISE_TYPES.SE_DIGITAL_VAC:
                        case CAMPAING_PROMISE_TYPES.NO_PLAY_SOV_2_0:                            
                            setEnvironment(orderlinesData.playData.plays.environment);
                            break;
                        default:
                            console.error('campaignPromiseType in environment not mapped');
                            showError('Failed to load Environment data. Please try again or contact support.');
                    }
                    break;
                case PRODUCT_TYPES.CLASSIC:
                    const postingData = [
                        ...orderlinesData.postingData.slice(0, orderlinesData.orderLineDataInformation.postingDataLength),
                        ...orderlinesData.podPostingData,
                    ];
                    switch (campaignPromiseType) {
                        case CAMPAING_PROMISE_TYPES.SE_CLASSIC_EAVAC:
                        case CAMPAING_PROMISE_TYPES.SE_CLASSIC_PANELS:
                        case CAMPAING_PROMISE_TYPES.SE_CLASSIC_PANELS_FILLER:
                        case CAMPAING_PROMISE_TYPES.SE_CLASSIC_PANELS_OI:
                        case CAMPAING_PROMISE_TYPES.NO_CLASSIC_PANELS_FILLER:
                        case CAMPAING_PROMISE_TYPES.NO_CLASSIC_PANELS:
                        case CAMPAING_PROMISE_TYPES.NO_CLASSIC_PANELS_2_0:
                        case CAMPAING_PROMISE_TYPES.NO_CLASSIC_PANELS_VAC_2_0:
                        case CAMPAING_PROMISE_TYPES.NO_CLASSIC_VAC_FILLER_2_0:
                        case CAMPAING_PROMISE_TYPES.NO_CLASSIC_VAC_2_0:                            
                        case CAMPAING_PROMISE_TYPES.DK_CLASSIC_PANELS:
                        case CAMPAING_PROMISE_TYPES.DK_CLASSIC_PANELS_2_0:
                        case CAMPAING_PROMISE_TYPES.DK_CLASSIC_PANELS_ADSHEL_2_0:
                        case CAMPAING_PROMISE_TYPES.SE_CLASSIC_VAC:
                        case CAMPAING_PROMISE_TYPES.SE_CLASSIC_PANELS_EAVAC_OI:                            
                            const numWeeks = postingData.length;
                            const groupedEnvironments = postingData
                                .flatMap(posting => posting.podEnvironments)
                                .reduce((acc, environment) => {
                                    const existingEnvironment = acc.find(item => item.name === environment.name);
                                    const totalQuantity = environment.classicScreensData.reduce((sum, screen) => sum + screen.quantity, 0);

                                    if (existingEnvironment) {
                                        existingEnvironment.value += environment.value;
                                        existingEnvironment.screens += environment.screens;
                                        existingEnvironment.vac += environment.vac;
                                        existingEnvironment.classicScreensTotal += totalQuantity;
                                    } else {
                                        acc.push({
                                            ...environment,
                                            classicScreensTotal: totalQuantity
                                        });
                                    }

                                    return acc;
                                }, [])
                                .map(env => ({
                                    ...env,
                                    classicScreens: parseFloat((env.classicScreensTotal / numWeeks).toFixed(1)) // Compute and round to 1 decimal
                                }));
                            setEnvironment(groupedEnvironments);
                            break;
                        default:
                            showError('Failed to load Environment data. Please try again or contact support.');
                            console.error('campaignPromiseType in environment not mapped');
                    }
                    break;
            }
        }

        switch (campaignPromiseType) {
            case CAMPAING_PROMISE_TYPES.SE_CLASSIC_EAVAC:
            case CAMPAING_PROMISE_TYPES.SE_DIGITAL_EAVAC:
            case CAMPAING_PROMISE_TYPES.SE_DIGITAL_EAVAC_FILLER:
                setYLabel('EA-VAC');
                break;
            case CAMPAING_PROMISE_TYPES.NO_PLAY_VAC_FILLER:
            case CAMPAING_PROMISE_TYPES.NO_PLAY_VAC:
            case CAMPAING_PROMISE_TYPES.DK_PLAY_VAC_PANELS:
            case CAMPAING_PROMISE_TYPES.DK_PLAY_VAC:
            case CAMPAING_PROMISE_TYPES.DK_AIRPORT_VAC_PANELS:
            case CAMPAING_PROMISE_TYPES.DK_AIRPORT_VAC:
            case CAMPAING_PROMISE_TYPES.DK_PLAY_VAC_PANELS_2_0:
            case CAMPAING_PROMISE_TYPES.DK_PLAY_VAC_2_0:
            case CAMPAING_PROMISE_TYPES.DK_AIRPORT_VAC_PANELS_2_0:
            case CAMPAING_PROMISE_TYPES.DK_AIRPORT_VAC_2_0:                
                setYLabel('VAC');
                break;
            case CAMPAING_PROMISE_TYPES.NO_PLAY_VAC_2_0:
            case CAMPAING_PROMISE_TYPES.NO_PLAY_VAC_FILLER_2_0:
            case CAMPAING_PROMISE_TYPES.NO_PLAY_VAC_2_0:
            case CAMPAING_PROMISE_TYPES.NO_PLAY_VAC_FILLER_2_0:
            case CAMPAING_PROMISE_TYPES.NO_CLASSIC_VAC_2_0:
            case CAMPAING_PROMISE_TYPES.NO_CLASSIC_VAC_FILLER_2_0:
                setYLabel('VAC/VI');
                break;
            case CAMPAING_PROMISE_TYPES.SE_DIGITAL_SOV:                
            case CAMPAING_PROMISE_TYPES.SE_CLASSIC_PANELS:
            case CAMPAING_PROMISE_TYPES.SE_CLASSIC_PANELS_FILLER:
            case CAMPAING_PROMISE_TYPES.SE_CLASSIC_PANELS_OI:
            case CAMPAING_PROMISE_TYPES.SE_CLASSIC_VAC:
            case CAMPAING_PROMISE_TYPES.SE_CLASSIC_PANELS_EAVAC_OI:
            case CAMPAING_PROMISE_TYPES.NO_CLASSIC_PANELS_FILLER:
            case CAMPAING_PROMISE_TYPES.NO_CLASSIC_PANELS:
            case CAMPAING_PROMISE_TYPES.NO_CLASSIC_PANELS_2_0:
            case CAMPAING_PROMISE_TYPES.NO_CLASSIC_PANELS_VAC_2_0:
            case CAMPAING_PROMISE_TYPES.NO_PLAY_SOV_2_0:
            case CAMPAING_PROMISE_TYPES.DK_CLASSIC_PANELS:
            case CAMPAING_PROMISE_TYPES.DK_CLASSIC_PANELS_2_0:                
            case CAMPAING_PROMISE_TYPES.DK_CLASSIC_PANELS_ADSHEL_2_0:
            case CAMPAING_PROMISE_TYPES.DK_DIGITAL_SOV:
                setYLabel('Panels');
                break;
            case CAMPAING_PROMISE_TYPES.SE_DIGITAL_PLAYS:
            case CAMPAING_PROMISE_TYPES.SE_DIGITAL_NO_PROMISE:
            case CAMPAING_PROMISE_TYPES.NO_PLAY_PLAYS:
            case CAMPAING_PROMISE_TYPES.DK_PLAY_PLAYS:
            case CAMPAING_PROMISE_TYPES.DK_PLAY_PLAYS_2_0:                
            case CAMPAING_PROMISE_TYPES.SE_DIGITAL_VAC:
            case CAMPAING_PROMISE_TYPES.SE_DIGITAL_VAC:
            case CAMPAING_PROMISE_TYPES.NO_PLAY_PLAYS_2_0:
            case CAMPAING_PROMISE_TYPES.NO_AIRPORT_PLAYS_2_0_1:
                setYLabel('Plays');
                break;
            default:
                setYLabel('Data'); // Fallback label
        }
    }, [orderlinesData, campaignPromiseType]);

    const getValue = (item) => {
        switch (campaignPromiseType) {
            case CAMPAING_PROMISE_TYPES.SE_CLASSIC_EAVAC:
            case CAMPAING_PROMISE_TYPES.NO_CLASSIC_VAC_2_0:
            case CAMPAING_PROMISE_TYPES.NO_CLASSIC_VAC_FILLER_2_0:                
                return item.vac;
            case CAMPAING_PROMISE_TYPES.SE_DIGITAL_EAVAC:
            case CAMPAING_PROMISE_TYPES.SE_DIGITAL_EAVAC_FILLER:
            case CAMPAING_PROMISE_TYPES.SE_DIGITAL_VAC:
            case CAMPAING_PROMISE_TYPES.SE_DIGITAL_PLAYS: //plays
            case CAMPAING_PROMISE_TYPES.SE_DIGITAL_NO_PROMISE: //plays
            case CAMPAING_PROMISE_TYPES.NO_PLAY_PLAYS: //plays
            case CAMPAING_PROMISE_TYPES.DK_PLAY_PLAYS: //plays
            case CAMPAING_PROMISE_TYPES.DK_PLAY_PLAYS_2_0: //plays            
            case CAMPAING_PROMISE_TYPES.NO_PLAY_VAC_FILLER:
            case CAMPAING_PROMISE_TYPES.NO_PLAY_VAC:
            case CAMPAING_PROMISE_TYPES.NO_PLAY_PLAYS_2_0:   
            case CAMPAING_PROMISE_TYPES.NO_AIRPORT_PLAYS_2_0_1:             
            case CAMPAING_PROMISE_TYPES.NO_PLAY_VAC_2_0:
            case CAMPAING_PROMISE_TYPES.NO_PLAY_VAC_FILLER_2_0:                
            case CAMPAING_PROMISE_TYPES.DK_PLAY_VAC:
            case CAMPAING_PROMISE_TYPES.DK_PLAY_VAC_PANELS:
            case CAMPAING_PROMISE_TYPES.DK_AIRPORT_VAC:
            case CAMPAING_PROMISE_TYPES.DK_AIRPORT_VAC_PANELS:
            case CAMPAING_PROMISE_TYPES.DK_PLAY_VAC_2_0:
            case CAMPAING_PROMISE_TYPES.DK_PLAY_VAC_PANELS_2_0:
            case CAMPAING_PROMISE_TYPES.DK_AIRPORT_VAC_2_0:
            case CAMPAING_PROMISE_TYPES.DK_AIRPORT_VAC_PANELS_2_0:                
                return item.value;
            case CAMPAING_PROMISE_TYPES.SE_DIGITAL_SOV:
            case CAMPAING_PROMISE_TYPES.NO_PLAY_SOV_2_0:
            case CAMPAING_PROMISE_TYPES.DK_DIGITAL_SOV:
                return item.screens;
            case CAMPAING_PROMISE_TYPES.SE_CLASSIC_PANELS_OI:
            case CAMPAING_PROMISE_TYPES.SE_CLASSIC_PANELS:
            case CAMPAING_PROMISE_TYPES.SE_CLASSIC_PANELS_FILLER:
            case CAMPAING_PROMISE_TYPES.SE_CLASSIC_PANELS_EAVAC_OI:                
            case CAMPAING_PROMISE_TYPES.SE_CLASSIC_VAC:
            case CAMPAING_PROMISE_TYPES.NO_CLASSIC_PANELS_FILLER:
            case CAMPAING_PROMISE_TYPES.DK_CLASSIC_PANELS:
            case CAMPAING_PROMISE_TYPES.DK_CLASSIC_PANELS_2_0:                
            case CAMPAING_PROMISE_TYPES.DK_CLASSIC_PANELS_ADSHEL_2_0:
            case CAMPAING_PROMISE_TYPES.NO_CLASSIC_PANELS:
            case CAMPAING_PROMISE_TYPES.NO_CLASSIC_PANELS_2_0:
            case CAMPAING_PROMISE_TYPES.NO_CLASSIC_PANELS_VAC_2_0:                
                return item.classicScreens;
            default:
                return item.value;
        }
    };

    const renderChart = () => {
        chartRef.current = Highcharts.chart(containerRef.current, {
            chart: {
                type: "area",
            //    height: 200
            },
            title: {
                text: null
            },
            credits: false,
            xAxis: {
                categories: environment.map((x) => x.name),
                tickWidth: 1,
                labels: {
                    style: {
                        fontFamily: "'BauerMediaSans', sans-serif"
                    },
                },
            },
            yAxis: {
                title: {
                    text: yLabel,
                    style: {
                        fontSize: '11px',
                        fontFamily: "'BauerMediaSans', sans-serif"
                    }
                },
                labels: {
                    formatter: function () {
                        return this.value
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
                    },
                    style: {
                        fontSize: '11px',
                        fontFamily: "'BauerMediaSans', sans-serif"

                    }
                },
                min: Math.min(...environment.map((x) => getValue(x))) * 0.75
            },
            legend: {
                enabled: false
            },
            plotOptions: {
                series: {
                    enableMouseTracking: true,
                    dataLabels: {
                        enabled: true,
                        overflow: "allow",
                        crop: false,
                        style: {
                            fontWeight: "normal",
                            fontSize: '11px',
                            fontFamily: "'BauerMediaSans', sans-serif"
                        },
                        formatter: function () {
                            return this.y
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
                        },
                    }
                },
                area: {
                    fillOpacity: 1,
                    marker: {
                        enabled: false
                    }
                }
            },
            legend: {
                enabled: false
            },
            tooltip: {
                enabled: true,
                formatter: function () {
                    const header = `${this.key}<br/>`;
                    const body = `<span style="font-family: 'BauerMediaSansBold', sans-serif;color:${this.color}">\u25CF</span> ${this.series.name}: <b>${this.y
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}</b>`;
                    return header + body;
                },
                style: {
                    fontSize: '12px',
                    fontFamily: "'BauerMediaSans', sans-serif"
                }
            },
            series: [
                {
                    name: yLabel,
                    color: 'black',
                    type: "column",
                    data: environment.map((x) => getValue(x))
                }
            ]
        });
    };

    useEffect(() => {
        if (environment.length > 0) {
            renderChart();
        }
        const handleResize = () => {
            if (chartRef.current) {
                chartRef.current.reflow();
            }
        };

        window.addEventListener('resize', handleResize);

        return () => {
            // Cleanup on unmount
            window.removeEventListener('resize', handleResize);
        };
    }, [campaignType, environment]);

    return (
        <div className={styles.chartShadow}>
            <div className={styles.graphLabel}>
                <h4>Environment</h4>
            </div>
            <div 
                className={`
                    ${showDaysGraph ? styles.envGraph : styles.envGraphNoDays}
                    ${alignWithFooterNote ? styles.envGraphWithFootNote : ''}
                `}
                ref={containerRef} id="pod_environment_container">                
            </div>
        </div>
    );
};

export default EnvironmentPlay;
